















































































































































    import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
    import Util from '../../lib/util'
    import AbpBase from '../../lib/abpbase'
    import Goods from '../../store/entities/regularinspections'
    import UtilUrl from '../../lib/url'
    import appconst from '../../lib/appconst'
    import RegularInspections from '@/store/entities/regularinspections';
    import AppConsts from '../../lib/appconst'
 
    
     
    
    @Component
    export default class CreateRegularInspection extends AbpBase{


        
        @Prop({type:Boolean,default:false}) value:boolean;
    
         user:RegularInspections=new RegularInspections();
         token:string="";
         nowdom=appconst.remoteServiceBaseUrl+ "/api/services/app/RegularInspections/UploadFile";
        // filelist:any=null; 
         uploadFiles:any= [];
         nums:number=0;
       //  nowdom=appconst.remoteServiceBaseUrl+ "/uf/index";


     get vlist(){
            
          return this.$store.state.regularinspections.vareas;
     }   
   
    //获取初始值
    get regularinspectionstypeparentlist(){
         
            return this.$store.state.regularinspections.regularinspectionstypelst;
     }
      
      get regularinspectionstypelstz(){

          return this.$store.state.regularinspections.regularinspectionstypelstz;
      }
        
     

      async upfile(item){
      var _this=this;
         var formData = new FormData();
             formData.append("files", item);
                     

               await  this.$store.dispatch({
                        type:'regularinspections/uploadfile',
                        data:formData,
                        headers: {	'Content-Type': 'multipart/form-data',
                                },
                        
                    }).then(ret=>{
                           
                             
                             if(ret.filePath!=""){
                                 _this.nums++;
                                item.idx=_this.nums;

                                
                              const reader = new FileReader()
                                 reader.readAsDataURL(item);
                                 reader.onload = function (e) {
                                // 文件base64
                                  const fileBase64 = this.result
                                 if( _this.uploadFiles==null){
                                     _this.uploadFiles=new Array<Object>();
                                   }
                                
                                _this.uploadFiles.push({ idx:_this.nums, name: ret.filePath,url: fileBase64,status:'finished'})  
                                 }


                                
                             }else{
                                 //异常不执行
                                 
                                  this.$Message['error']({
                                 //    background: true,
                                   content: ret.msg
                                  });
                                   
                             }
                    });
                
            
       }
  
           handleFormatError (file) {
                 /*
                _this.$Notice.warning({
                                      title:'只支持图片格式[jpg,jpeg,png]'
                                  });*/
            }
       
     

        save(){

     (this.$refs.userForm as any).validate(async (valid:boolean)=>{
       
       if(valid){
          var  efid= window.sessionStorage.getItem("regularinspections_riefid");
             this.user.enterpriseinformationid=parseInt(efid) ;
            var filepath=[];
            var newfilelist= this.uploadFiles;
             
             newfilelist.forEach(element => {
                filepath.push(element.name);
             });
             
           //图片数组转字符串
   
           this.user.img="";
           

           if(filepath.length>0){
                this.user.img=filepath.join(",");
           }
       
         

          //开始处理数据

               await this.$store.dispatch({
                        type:'regularinspections/create',
                        data:this.user
                    });
                    (this.$refs.userForm as any).resetFields();
                    this.$emit('save-success');
                    this.$emit('input',false);



            }
           })
            /*
         
               (this.$refs.userForm as any).validate(async (valid:boolean)=>{
                if(valid){
                 
                    var  regularinspectionsimg= this.$store.state.regularinspections.uploadList
                    if(regularinspectionsimg!=null&&regularinspectionsimg.length>0){

                         this.user.img=regularinspectionsimg[0].url;
                    }
                    
                    await this.$store.dispatch({
                        type:'regularinspections/create',
                        data:this.user
                    });
                    (this.$refs.userForm as any).resetFields();
                    this.$emit('save-success');
                    this.$emit('input',false);
                }
            })*/
        }
 
        getDate(dataTime){
   
               this.user.createtime=  new Date(dataTime) ;
               
        }
        cancel(){
            (this.$refs.userForm as any).resetFields();
            this.$emit('input',false);
        }
        visibleChange(value:boolean){
            if(!value){
                this.$emit('input',value);
               
                this.$store.state.regularinspections.uploadList=null;
            }
        }
        created() {
  
             //this.token="Bearer "+Util.abp.utils.getCookieValue(AppConsts.authorization.encrptedAuthTokenName);

              var  efid= window.sessionStorage.getItem("regularinspections_riefid");
      
    
             this.user.enterpriseinformationid=parseInt(efid) ;
            
          
            
        }

        userRule={
          
            title:[{required: true,message:'请输入标题',trigger: 'blur'}],
            content:[{required: true,message:'请输入内容',trigger: 'blur'}],
            regularinspectionstype:[{type:'number', required: true,message:'请选择巡查类型',}],
            evaluate:[{type:'number', required: true,message:'请选择评价',}],
            operatorname:[{required: true,message:'请输入操作人',trigger: 'blur'}],
            createtime:[{type:'date',required: true,message:'请输选择日期',trigger: 'blur'}],
             
           
            
      
        }
 

          handleBeforeUpload (file) {
              
        if( this.uploadFiles!=null&&this.uploadFiles.length >=5){
               
          this.$Message['error']({
                    content: '最多上传5张图片',
                    duration:2
                });
                return false;        
        }
           
        

           this.upfile(file)
 
            return false ;
     }

    handleRemove (file) {
             
                 var index=-1;
                 var list=this.uploadFiles;
                   for(var i=0;i<list.length;i++){

                     if(list[i].idx==file.idx){
                             index=i;  
                          }
                   }
                
                  this.uploadFiles.splice(index, 1);
                 //  this. filelist.splice(index, 1);



            }
   handleSuccess (res, file) {
      /*
          let _this = this
         if(file.response.result!=null){
             var fileUrl=file.response.result.fileUrl;
             let lst=this.$store.state.regularinspections.uploadList;
           if(lst==null){
                  lst=[];
                  
           }
         lst.push({ name:fileUrl,url: fileUrl,status:'finished'});

          _this.$store.state.regularinspections.uploadList =lst; */
      }

        
                // 因为上传过程为实例，这里模拟添加 url
              //  file.url = 'https://o5wwk8baw.qnssl.com/7eb99afb9d5f317c912f08b5212fd69a/avatar';
              //  file.name = '7eb99afb9d5f317c912f08b5212fd69a';
         //   }
/*
  //预览
  getFileOthers (e) {
                //附件预览----合同及其他扫描件
       let _this = this
       var files = e.target.files[0];
       console.log(e.target.files[0]);
       if (!e || !window.FileReader) return  // 看支持不支持FileReader
       let reader = new FileReader()
       reader.readAsDataURL(files) // 这里是最关键的一步，转换就在这里
       reader.onloadend = function () {
        console.log(this.result);
         _this.$store.state.regularinspections.srcOthers = this.result
      }
    }
    
   */
        
    }  

    

    
   
